(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["menu-grid"] && !Shopify.designMode) return;
  try {
    
(function () {

  // ── Filter ──────────────────────────────────────
  var filterBtns = document.querySelectorAll('.menu-filter__btn');
  var gridItems  = document.querySelectorAll('.menu-grid__item, .menu-grid__spacer');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var filter = btn.getAttribute('data-filter');

      filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      gridItems.forEach(function (item) {
        if (item.classList.contains('menu-grid__spacer')) {
          item.classList.toggle('is-hidden', filter !== 'all');
          return;
        }
        var matches = filter === 'all' || item.getAttribute('data-category') === filter;
        item.classList.toggle('is-hidden', !matches);
      });
    });
  });

  // ── Modal ──────────────────────────────────────
  var modal       = document.getElementById('menuModal');
  var overlay     = document.getElementById('modalOverlay');
  var closeBtn    = document.getElementById('modalClose');
  var modalImage  = document.getElementById('modalImage');
  var modalEyebrow = document.getElementById('modalEyebrow');
  var modalName   = document.getElementById('modalItemName');
  var modalDesc   = document.getElementById('modalDescription');
  var lastFocused = null;

  var categoryLabels = {
    sando:   'Sando',
    bowl:    'Bowl',
    special: 'Special',
    side:    'Side',
    drink:   'Drink'
  };

  function openModal(item) {
    lastFocused = document.activeElement;

    var name  = item.getAttribute('data-name')  || '';
    var desc  = item.getAttribute('data-description') || '';
    var image = item.getAttribute('data-image') || '';
    var cat   = item.getAttribute('data-category') || '';

    modalName.textContent    = name;
    modalDesc.textContent    = desc;
    modalEyebrow.textContent = categoryLabels[cat] || cat;

    if (image) {
      modalImage.src = image;
      modalImage.alt = name;
      modalImage.parentElement.style.display = '';
    } else {
      modalImage.src = '';
      modalImage.parentElement.style.display = 'none';
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  // Bind grid triggers
  document.querySelectorAll('.menu-grid__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openModal(trigger.closest('.menu-grid__item'));
    });
  });

  // Close on overlay / button / ESC
  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Focus trap
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  });

}());

  } catch(e) { console.error(e); }
})();
})();
